// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"AssistantText_textWrapper__1_WZm","assistantText":"AssistantText_assistantText__U7XIU","active":"AssistantText_active__3rJpg","error":"AssistantText_error__13ixS"};